export default {
    filesSelect: {
        files: "Файли",
        download: "Завантажити",
        moreThanOneSignificantFile: "Більше ніж один значимий файл, автозавантаження не спрацює",
    },
    multiTaskPresets: {
        presets: "Пресети",
        saveAs: "Зберегти як",
        edit: "Редагувати",
        delete: "Видалити",
        apply: "Застосувати",
        enterPresetName: "Введіть назву пресету",
        cancellation: "Скасувати",
        dataForPresetNotSelected: "Не вибрані дані для пресету",
        presetWithThisNameAlredyExist: "Пресет з таким ім'ям вже існує",
        selectedNewElements: "Обрано нові елементи?",
        deleteSelectedPreset: "Видалити вибраний пресет?",
    },
    resultLogButton: {
        result: "Результат"
    },
    runTaskForm: {
        close: "Закрити",
        cancel: "Скасувати",
        start: "Запуск",
        accept: "Підтвердити",
        fileSelect: "Вибір файлу",
        dataBase: "База даних",
        fileSelect: "Вибір файлу",
        comment: "Коментар",
        cmdLine: "Рядок cmdLine:",
        taskStarted: "Завдання запущене",
        taskCompleted: "Завдання завершене",
        withError: "помилково",
        taskHelp: "Допомога по завданню",
        launchOnAllBases: "Запуск на всіх базах",
        fileMustBePresent: "Повинен бути присутнім файл",
        inappropriateNumberFormat: "Непридатний формат числа в рядку номер",
        inappropriateFloatFormat: "Непридатний формат числа з плаваючою крапкою в рядку номер",
        allFieldsMustBeEntered: "Все поля повинні бути введені",
        checkFieldsContent: "Перевірте вміст полів!",
        oneOrAllFieldsNotFilled: "Одне або кілька полів незаповнені",
        noAppTypeInFileName: "Не знайдено типу програми в назві файлу, приймається як admin",
        uncorrectFileForAppRefresh: "Невірний файл оновлення для поточної програми",
        plsRefreshPage: "Поновiть, будь ласка, сторінку",
        noHelpOnThisTaskCtrlEnter: "На це завдання немає допомоги. Ctrl + Enter - запуск завдання"
    },
    statusGrid: {
        files: "Файли",
        download: "Завантажити",
        watchLog: "Дивитися лог",
        delete: "Видалити",
        deleteSelected: "Видалити лише обрані задачі",
        restore: "Відновити",
        emptyTrash: "Очистити кошик",
        zombies: {
            emergency: "Позаштатна ситуація",
            clearZombies: "Очистити завдання, що завислі",
            withHttp: 'Видаляти на серверах, що не відповідають',
            withoutHttp: 'Не видаляти на серверах, що не відповідають',
            noTasksNoProblems: "Завислих завдань не знайдено, проблем не знайдено",
            tasksCleared: "Завислих завдань перервано: {number}",
            tasksAndZombies: "Завислих завдань перервано: {number}, знайдено зомбі-процесів: {zombie}",
            zombies: "Знайдено зомбі-процесів: {zombie}",
            noTasksCleared: "Завислих завдань не знайдено",
            errorsOnServers: "Знайдено помилки на серверах",
            warningsServers: "Повідомлення від серверів:",
            tasksInfo: "Інформація про ці завдання знаходиться в Статус завдань — Завершені, поле Примітка",
            goToAdmin: "Прохання повідомити розробників (консультанту з Linux) для зняття зомбі-процесів та звільнення ресурсів"
        },
        view: "Вигляд",
        compact: "Оптимальний",
        full: "Повний",
        refresh: "Оновити",
        leaveInLast: "Залишити за останні",
        days: "днів",
        completed: "завершення",
        stated: "запущені",
        thisActionRemoveAllToTrash: "Ця дія перенесе в кошик усі задачі",
        tasksAfter: "завдання після",
        daysFromToday: "дня (-ів) від сьогодні",
        attention: "Увага",
        cancellation: "Скасувати",
        uncorrectNumberOfDays: "Невірно вказано число днів",
        willRemove: "видалить обране | видалить обрані",
        willRestore: "відновить обране | відновить обрані",
        willCleanse: "очистить обране | очистить обрані",
        thisAction: "Ця дія {action} {task}. Продовжити?",
        thisTask: "завдання",
        continue: "Продовжити",
        cancel: "Назад",
        thisActionCleanseAllRemovedTasks: "Ця дія очистить всі видалені завдання. Продовжити?",
        thisActionCleanseSelectedRemovedTasks: "Ця дія очистить обране видалене завдання. Продовжити? | Ця дія очистить обрані видалені завдання. Продовжити?"
    },
    taskStatus: {
        completedTaskResult: "Результати виконання завдання",
        taskStarted: "завдання запущене",
        taskCompleted: "завдання завершене",
        timeoutExceeded: "перевищено таймаут",
        taskTerminatedAbnormally: "завдання аварійно завершене",
        taskInProcess: "Дане завдання в процесі роботи",
        thisTaskTimedOut: "Дане завдання перевищило таймаут веб-сторінки",
    }
}